<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24" class="time">
          {{ this.$moment().tz('Asia/Taipei').format('YYYY/MM/DD HH:mm') }}
      </el-col>
    </el-row>
    <el-form ref="ruleForm" :model="content" size="small" :rules="rules" label-width="auto" v-loading="loading"
      class="alarm-form">
      <el-card class="box-card">
        <div slot="header">
          用戶聯絡資訊
        </div>
        <el-row>
          <el-col>
            <!-- <el-form-item label="手機簡訊" prop="notifyPhones" >
                  <el-input v-model="content.notifyPhones"></el-input>
                </el-form-item> -->
            <el-form-item v-if="content" label="手機簡訊" prop="notifyPhones" :inline-message="true">
              <div v-if="content.notifyPhones.length == 0">
                <el-input v-model="content.notifyPhones[0]"></el-input>
              </div>
              <div v-else v-for="(item, index) in content.notifyPhones" :key="index" class="form-input">
                <el-input v-model="content.notifyPhones[index]"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item v-if="content" label="電子郵件" prop="notifyMails">
              <div v-for="(e, index) in 5" :key="index" class="form-input">
                <el-input v-model="content.notifyMails[index]"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card">
        <div slot="header">
          警示設定管理
        </div>
        <el-form ref="ruleContentForm" :model="ruleContent" size="small" :rules="rules" label-width="auto">

          <el-row class="mb-10">
            <el-col>
              <el-radio-group v-model="alarmRadio">
                <el-radio label="radio0">無警示</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>

          <el-row class="mb-10" :gutter="20">
            <el-col :span="5" :xs="24">
              <p class="alarm-form-title">連續七天累積用水量</p>
            </el-col>
            <el-col :span="19" :xs="24">
              <el-radio-group v-model="alarmRadio">
                <el-radio :label="alarmSetting.radio1.label">較上週增加</el-radio>
                <el-radio :label="alarmSetting.radio2.label">較最近一月的週平均用水量突增</el-radio>
                <el-radio :label="alarmSetting.radio3.label">較去年同期突增</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>

          <el-row class="mb-10" :gutter="20">
            <el-col :span="5" :xs="24">
              <p class="alarm-form-title">連續三十天累積用水量</p>
            </el-col>
            <el-col :span="19" :xs="24">
              <el-radio-group v-model="alarmRadio">
                <el-radio :label="alarmSetting.radio4.label" size="small" class="custom-option">較去年同期突增</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>


          <el-row class="mb-10">
            <el-col class="bg-gray">
              <p class="color-red mb-10">挑選上方警示後請設定警示的百分比或警示值(若無警示不需填寫)</p>
              <p v-if="alarmRadio == alarmSetting.radio1.label" class="p-inline">
                <el-form-item label="" prop="radio1PercentInput" :show-message="false">
                  較上週增加
                  <el-input-number v-model="ruleContent.radio1PercentInput" :controls="false" @keydown.native="paramInput"
                    style="width: 100px;" size="small" />
                </el-form-item>
                <el-form-item label="" prop="radio1VolumeInput" :show-message="false">
                  %且
                  <el-input-number v-model="ruleContent.radio1VolumeInput" :controls="false" @keydown.native="paramInputFloat" :step="0.1" :precision="2"
                    style="width: 100px;" size="small" />
                  度以上
                </el-form-item>
              </p>
              <p v-if="alarmRadio == this.alarmSetting.radio2.label" class="p-inline">
                <el-form-item label="" prop="radio2PercentInput" :show-message="false">
                  較最近一月的週平均用水量突增
                  <el-input-number v-model="ruleContent.radio2PercentInput" :controls="false" @keydown.native="paramInput"
                    style="width: 100px;" size="small" />
                  %且
                </el-form-item>
                <el-form-item label="" prop="radio2VolumeInput" :show-message="false">
                  <el-input-number v-model="ruleContent.radio2VolumeInput" :controls="false" @keydown.native="paramInputFloat" :step="0.1" :precision="2"
                    style="width: 100px;" size="small" />
                  度以上
                </el-form-item>
              </p>
              <p v-if="alarmRadio == this.alarmSetting.radio3.label" class="p-inline">
                <el-form-item label="" prop="radio3PercentInput" :show-message="false">
                  較去年同期突增
                  <el-input-number v-model="ruleContent.radio3PercentInput" :controls="false" @keydown.native="paramInput"
                    style="width: 100px;" size="small" />
                  %且
                </el-form-item>
                <el-form-item label="" prop="radio3VolumeInput" :show-message="false">
                  <el-input-number v-model="ruleContent.radio3VolumeInput" :controls="false" @keydown.native="paramInputFloat"  :step="0.1" :precision="2"
                    style="width: 100px;" size="small" />
                  度以上
                </el-form-item>
              </p>
              <p v-if="alarmRadio == this.alarmSetting.radio4.label" class="p-inline">
                <el-form-item label="" prop="radio4PercentInput" :show-message="false">
                  較去年同期突增
                  <el-input-number v-model="ruleContent.radio4PercentInput" :controls="false" @keydown.native="paramInput"
                    style="width: 100px;" size="small" />
                  %且
                </el-form-item>
                <el-form-item label="" prop="radio4VolumeInput" :show-message="false">
                  <el-input-number v-model="ruleContent.radio4VolumeInput" :controls="false" @keydown.native="paramInputFloat"  :step="0.1" :precision="2"
                    style="width: 100px;" size="small" />
                  度以上
                </el-form-item>
              </p>
              <p v-if="alarmRadio == 'radio0'">
                無警示
              </p>
            </el-col>
          </el-row>

          <el-row class="mb-10">
            <el-col>
              <p class="alarm-form-title">進階設定(可複選)</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="alarm-form-check p-inline">
                <el-checkbox-group v-model="advancedCheckList">
                  <el-checkbox :label="alarmSetting.checkbox1.label">夜間用水(01:00~06:00期間)大於連續七天的平均日用水量</el-checkbox>
                </el-checkbox-group>
                <el-form-item label="" prop="checkbox1PercentInput" :show-message="false"> 
                  <el-input-number v-model="ruleContent.checkbox1PercentInput" :controls="false"
                    @keydown.native="paramInput" style="width: 100px;" size="small" />
                  %(含)且
                </el-form-item>
                <el-form-item label="" prop="checkbox1VolumeInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox1VolumeInput" :controls="false"
                    @keydown.native="paramInputFloat"  :step="0.1" :precision="2" style="width: 100px;" size="small" />
                  度以上
                </el-form-item>
              </div>
              <div class="alarm-form-check p-inline">
                <el-checkbox-group v-model="advancedCheckList">
                  <el-checkbox :label="alarmSetting.checkbox2.label">夜間用水(01:00~06:00期間)較前一日增加達</el-checkbox>
                </el-checkbox-group>
                <el-form-item label="" prop="checkbox2PercentInput" :show-message="false" class="formItem-checkbox"> 
                  <el-input-number v-model="ruleContent.checkbox2PercentInput" :controls="false"
                    @keydown.native="paramInput" style="width: 100px;" size="small" />
                  %(含)且
                </el-form-item>
                <el-form-item label="" prop="checkbox2VolumeInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox2VolumeInput" :controls="false"
                    @keydown.native="paramInputFloat"  :step="0.1" :precision="2" style="width: 100px;" size="small" />
                  度以上
                </el-form-item>
              </div>
              <div class="alarm-form-check p-inline">
                <el-checkbox-group v-model="advancedCheckList">
                  <el-checkbox :label="alarmSetting.checkbox3.label">逆流：日反向累積量大於日正向累積量的</el-checkbox>
                </el-checkbox-group>
                <el-form-item label="" prop="checkbox3PercentInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox3PercentInput" :controls="false"
                    @keydown.native="paramInput" style="width:60px; margin: 0px 10px;" />
                  %(含)以上
                </el-form-item>
              </div>
              <div class="alarm-form-check p-inline">
                <el-checkbox-group v-model="advancedCheckList">
                  <el-checkbox :label="alarmSetting.checkbox4.label">連續用水達</el-checkbox>
                </el-checkbox-group>
                <el-form-item label="" prop="checkbox4DaysInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox4DaysInput" :controls="false" @keydown.native="paramInput"
                    style="width:60px; margin: 0px 10px;" />
                  日警示
                </el-form-item>
              </div>
              <div class="alarm-form-check p-inline">
                <el-checkbox-group v-model="advancedCheckList">
                  <el-checkbox :label="alarmSetting.checkbox5.label">連續不用水達</el-checkbox>
                </el-checkbox-group>
                <el-form-item label="" prop="checkbox5DaysInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox5DaysInput" :controls="false" @keydown.native="paramInput"
                    style="width:60px; margin: 0px 10px;" />
                  日警示
                </el-form-item>
              </div>
              <div class="alarm-form-check p-inline">
                <el-checkbox-group v-model="advancedCheckList">
                  <el-checkbox :label="alarmSetting.checkbox6.label">連續不用水達</el-checkbox>
                </el-checkbox-group>
                <el-form-item label="" prop="checkbox6DaysInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox6DaysInput" :controls="false" @keydown.native="paramInput"
                    style="width:60px; margin: 0px 10px;" />
                  日警示，指定時間
                </el-form-item>
                <el-form-item label="" prop="checkbox6HourStartInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox6HourStartInput" :controls="false"
                    @keydown.native="paramInputFloat" style="width: 100px;" size="small" />
                  時至
                </el-form-item>
                <el-form-item label="" prop="checkbox6HourEndInput" :show-message="false" class="formItem-checkbox">
                  <el-input-number v-model="ruleContent.checkbox6HourEndInput" :controls="false"
                    @keydown.native="paramInputFloat" style="width: 100px;" size="small" />
                  時
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <div class="align-center">
        <el-button :loading="saveBtnLoading" style="margin: 20px 0 0;" size="median" type="primary"
          @click="saveRule()">儲存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { ALARM_RULE_CODE } from '@/const/const'
import _ from 'lodash'

export default {
  // 警示設定
  name: 'AlarmSetting',
  components: {
  },
  data() {
    // 校驗 電子郵件格式
    let checkNotifyMails = (rule, value, callback) => {
      if (!value || value.length === 0) {
        return callback(); // 不做檢查
      }

      for (let email of value) {
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          return callback(new Error("請輸入有效的電子郵件"));
        }
      }

      callback()
    }
    // 校驗 手機簡訊格式
    let checkNotifyPhones = (rule, value, callback) => {
      if (!value || value.length === 0) {
        return callback();
      }

      const phoneRegex = /^09\d{8}$/; // 台灣手機號碼格式 09xxxxxxxx
      for (let phone of value) {
        if (phone && !phoneRegex.test(phone)) {
          return callback(new Error("請輸入有效的手機號碼"));
        }
      }

      callback();
    }
    // // 確認是否 全為 空字串
    // function checkAryEmpty(arr) {
    //   let empty = 1
    //   arr.forEach(element => {
    //     if (element == '') {
    //       empty = empty && 1
    //     } else {
    //       empty = empty && 0
    //     }
    //   });
    //   return empty
    // }

    let checkRadio1 = (rule, value, callback) => {
      if (this.alarmRadio == this.alarmSetting.radio1.label) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }

    let checkRadio2 = (rule, value, callback) => {
      if (this.alarmRadio == this.alarmSetting.radio2.label) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }

    let checkRadio3 = (rule, value, callback) => {
      if (this.alarmRadio == this.alarmSetting.radio3.label) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }

    let checkRadio4 = (rule, value, callback) => {
      if (this.alarmRadio == this.alarmSetting.radio4.label) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }

    let checkbox1 = (rule, value, callback) => {
      if (this.advancedCheckList && this.advancedCheckList.length > 0 && this.advancedCheckList.includes(this.alarmSetting.checkbox1.label)) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }
    let checkbox2 = (rule, value, callback) => {
      if (this.advancedCheckList && this.advancedCheckList.length > 0 && this.advancedCheckList.includes(this.alarmSetting.checkbox2.label)) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }
    let checkbox3 = (rule, value, callback) => {
      if (this.advancedCheckList && this.advancedCheckList.length > 0 && this.advancedCheckList.includes(this.alarmSetting.checkbox3.label)) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }
    let checkbox4 = (rule, value, callback) => {
      if (this.advancedCheckList && this.advancedCheckList.length > 0 && this.advancedCheckList.includes(this.alarmSetting.checkbox4.label)) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }
    let checkbox5 = (rule, value, callback) => {
      if (this.advancedCheckList && this.advancedCheckList.length > 0 && this.advancedCheckList.includes(this.alarmSetting.checkbox5.label)) {
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }
    let checkbox6 = (rule, value, callback) => {
      if (this.advancedCheckList && this.advancedCheckList.length > 0 && this.advancedCheckList.includes(this.alarmSetting.checkbox6.label)) {
        if (this.ruleContent.checkbox6DaysInput < 1){
          return callback(new Error("(警示需>=1日)"))
        }
        if ( this.ruleContent.checkbox6HourEndInput > 24
          || this.ruleContent.checkbox6HourStartInput >= this.ruleContent.checkbox6HourEndInput
        ){
          return callback(new Error("(指定時間不得跨日)"))
        }
        return checkEmpty(rule, value, callback)
      } else {
        return callback()
      }
    }

    // 
    let checkEmpty = (rule, value, callback) => {
      if (!value) {
        if (value == 0) {
          return callback()
        } else {
          callback(new Error("(必填)"))
        }
      } else {
        return callback()
      }
    }

    return {
      loading: false,
      saveBtnLoading: false,
      content: undefined, // 設定內容
      rules: {
        notifyMails: [{ required: false, validator: checkNotifyMails, trigger: 'blur' }],
        notifyPhones: [{ required: false, validator: checkNotifyPhones, trigger: 'blur' }],
        radio1PercentInput: [{ validator: checkRadio1, trigger: 'blur' }],
        radio1VolumeInput: [{ validator: checkRadio1, trigger: 'blur' }],
        radio2PercentInput: [{ validator: checkRadio2, trigger: 'blur' }],
        radio2VolumeInput: [{ validator: checkRadio2, trigger: 'blur' }],
        radio3PercentInput: [{ validator: checkRadio3, trigger: 'blur' }],
        radio3VolumeInput: [{ validator: checkRadio3, trigger: 'blur' }],
        radio4PercentInput: [{ validator: checkRadio4, trigger: 'blur' }],
        radio4VolumeInput: [{ validator: checkRadio4, trigger: 'blur' }],
        checkbox1PercentInput: [{ validator: checkbox1, trigger: 'blur' }],
        checkbox1VolumeInput: [{ validator: checkbox1, trigger: 'blur' }],
        checkbox2PercentInput: [{ validator: checkbox2, trigger: 'blur' }],
        checkbox2VolumeInput: [{ validator: checkbox2, trigger: 'blur' }],
        checkbox3PercentInput: [{ validator: checkbox3, trigger: 'blur' }],
        checkbox4DaysInput: [{ validator: checkbox4, trigger: 'blur' }],
        checkbox5DaysInput: [{ validator: checkbox5, trigger: 'blur' }],
        checkbox6DaysInput: [{ validator: checkbox6, trigger: 'blur' }],
        checkbox6HourStartInput: [{ validator: checkbox6, trigger: 'blur' }],
        checkbox6HourEndInput: [{ validator: checkbox6, trigger: 'blur' }],
      },
      alarmRadio: undefined,
      advancedCheckList: [],
      ruleContent: {
        radio1PercentInput: 30,
        radio1VolumeInput: 10,
        radio2PercentInput: 30,
        radio2VolumeInput: 10,
        radio3PercentInput: 30,
        radio3VolumeInput: 10,
        radio4PercentInput: 30,
        radio4VolumeInput: 10,
        checkbox1PercentInput: '',
        checkbox1VolumeInput: '',
        checkbox2PercentInput: '',
        checkbox2VolumeInput: '',
        checkbox3PercentInput: '',
        checkbox4DaysInput: '',
        checkbox5DaysInput: '',
        checkbox6DaysInput: '',
        checkbox6HourStartInput: '',
        checkbox6HourEndInput: '',
      },
      alarmSetting: {
        status: {
          col: 'method',
          enable: 'overwrite',
          disable: 'disable'
        },
        radio1: {
          label: 'radio1',
          alarmRule: 'r0413', // r0405 to r0413, 20230710
        },
        radio2: {
          label: 'radio2',
          alarmRule: 'r0414', // r0412 to r0414, 20230710
        },
        radio3: {
          label: 'radio3',
          alarmRule: 'r0415', // r0403 to r0415, 20230710
        },
        radio4: {
          label: 'radio4',
          alarmRule: 'r0416', // r0406 to r0416, 20230710
        },
        checkbox1: {
          label: 'checkbox1',
          alarmRule: 'r0801',
        },
        checkbox2: {
          label: 'checkbox2',
          alarmRule: 'r0802',
        },
        checkbox3: {
          label: 'checkbox3',
          alarmRule: 'r0302',
        },
        checkbox4: {
          label: 'checkbox4',
          alarmRule: 'r0502', // r0501 to r0502, 20230710
        },
        checkbox5: {
          label: 'checkbox5',
          alarmRule: 'r0703', // r0701 to r0703, 20230710
        },
        checkbox6: {
          label: 'checkbox6',
          alarmRule: 'r0704',
        },
      }
    };
  },
  async created() {
    this.loading = true
    try{
      await this.$store.dispatch("getAlarmCategory")
      await this.getAlarmRules()  // 取得告警規則資料
    }catch(ex) {
      this.$message({
        message: '發生錯誤',
        type: 'error'
      })
    }finally{
      this.loading = false
    }
    
  },
  computed: {
    currentWaterNum() {
      // 取得目前的WaterNum
      return JSON.parse(localStorage.getItem('currentProfile')).waterNum
    }
  },
  watch: {
    alarmRadio(newVal) {
      if(newVal == 'radio0') {
        // 選擇無警示時，清除所有進階條件勾選。
        this.advancedCheckList = []
      }

      const _formRef = this.$refs['ruleContentForm']
      // 更換選項時清除Valid
      if (_formRef) {
        _formRef.clearValidate()
      }
    },

    // 進階設定 checkbox list
    advancedCheckList(newVal) {
      const _formRef = this.$refs['ruleContentForm']

      // 更換選項時清除Valid
      if (_.isArray(newVal)) {

        // 如果有任何選項勾選且無警示勾選時，清除無警示的勾選。
        if(newVal.length > 0 && this.alarmRadio == 'radio0') {
          // 清除無警示勾選
          this.alarmRadio = undefined
        }

        // checkbox1未勾選時，清除相關的Valid
        if (!newVal.includes(this.alarmSetting.checkbox1.label)) {
          _formRef.clearValidate(['checkbox1PercentInput', 'checkbox1VolumeInput'])
          this.ruleContent.checkbox1PercentInput = 0
          this.ruleContent.checkbox1VolumeInput = 0
        }
        // checkbox2未勾選時，清除相關的Valid
        if (!newVal.includes(this.alarmSetting.checkbox2.label)) {
          _formRef.clearValidate(['checkbox2PercentInput', 'checkbox2VolumeInput'])
          this.ruleContent.checkbox2PercentInput = 0
          this.ruleContent.checkbox2VolumeInput = 0
        }
        // checkbox3未勾選時，清除相關的Valid
        if (!newVal.includes(this.alarmSetting.checkbox3.label)) {
          _formRef.clearValidate('checkbox3PercentInput')
          this.ruleContent.checkbox3PercentInput = 0
        }
        // checkbox4未勾選時，清除相關的Valid
        if (!newVal.includes(this.alarmSetting.checkbox4.label)) {
          _formRef.clearValidate('checkbox4DaysInput')
          this.ruleContent.checkbox4DaysInput = 0
        }
        // checkbox5未勾選時，清除相關的Valid
        if (!newVal.includes(this.alarmSetting.checkbox5.label)) {
          _formRef.clearValidate('checkbox5DaysInput')
          this.ruleContent.checkbox5DaysInput = 0
        }
        // checkbox6未勾選時，清除相關的Valid
        if (!newVal.includes(this.alarmSetting.checkbox6.label)) {
          _formRef.clearValidate(['checkbox6DaysInput', 'checkbox6HourStartInput', 'checkbox6HourEndInput'])
          this.ruleContent.checkbox6DaysInput = 0
          this.ruleContent.checkbox6HourStartInput = 0
          this.ruleContent.checkbox6HourEndInput = 24
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    // 取得告警規則資料
    async getAlarmRules() {
      await this.axios.get('/api/alarm/rule/waterNum/' + this.currentWaterNum + '/citizen').then(res => {
        this.content = res.data
        let tempRuleData = _.cloneDeep(this.content.rules)
        tempRuleData = this.processRuleData(tempRuleData)
        this.setRuleContent(tempRuleData)
      })
        .catch(err => {
          this.$message({ message: '無法擷取資料!', type: 'warning' })
          console.error(err)
        })

    },
    // 整理告警規則
    processRuleData(ruleData) {
      // 先移除 null 的規則
      for (let key in ruleData) {
        if (ruleData[key] == null) {
          delete ruleData[key]
        }
      }
      // 過濾出水管家可管理之規則
      ruleData = Object.keys(ruleData)
        .filter(key => ALARM_RULE_CODE.includes(key))
        .reduce((obj, key) => {
          obj[key] = ruleData[key]
          return obj
        }, {})

      // 物件內新增 code property 辨別
      for (let key in ruleData) {
        ruleData[key]['code'] = key
      }
      return ruleData
    },
    // 設定畫面資料
    setRuleContent(ruleData) {
      const _statusCol = this.alarmSetting.status.col
      const _enable = this.alarmSetting.status.enable

      // 依據啟用規則設定Rule Radio
      if (ruleData[this.alarmSetting.radio1.alarmRule] && ruleData[this.alarmSetting.radio1.alarmRule][_statusCol] == _enable) {
        // radio1啟用時，於畫面初始相關欄位值
        this.alarmRadio = this.alarmSetting.radio1.label
        this.ruleContent.radio1PercentInput = ruleData[this.alarmSetting.radio1.alarmRule].percentage
        this.ruleContent.radio1VolumeInput = ruleData[this.alarmSetting.radio1.alarmRule].volume
      } else if (ruleData[this.alarmSetting.radio2.alarmRule] && ruleData[this.alarmSetting.radio2.alarmRule][_statusCol] == _enable) {
        // radio2啟用時，於畫面初始相關欄位值
        this.alarmRadio = this.alarmSetting.radio2.label
        this.ruleContent.radio2PercentInput = ruleData[this.alarmSetting.radio2.alarmRule].percentage
        this.ruleContent.radio2VolumeInput = ruleData[this.alarmSetting.radio2.alarmRule].volume
      } else if (ruleData[this.alarmSetting.radio3.alarmRule] && ruleData[this.alarmSetting.radio3.alarmRule][_statusCol] == _enable) {
        // radio3啟用時，於畫面初始相關欄位值
        this.alarmRadio = this.alarmSetting.radio3.label
        this.ruleContent.radio3PercentInput = ruleData[this.alarmSetting.radio3.alarmRule].percentage
        this.ruleContent.radio3VolumeInput = ruleData[this.alarmSetting.radio3.alarmRule].volume
      } else if (ruleData[this.alarmSetting.radio4.alarmRule] && ruleData[this.alarmSetting.radio4.alarmRule][_statusCol] == _enable) {
        // radio4啟用時，於畫面初始相關欄位值
        this.alarmRadio = this.alarmSetting.radio4.label
        this.ruleContent.radio4PercentInput = ruleData[this.alarmSetting.radio4.alarmRule].percentage
        this.ruleContent.radio4VolumeInput = ruleData[this.alarmSetting.radio4.alarmRule].volume
      }

      // 依據啟用規則設定checkbox
      if (ruleData[this.alarmSetting.checkbox1.alarmRule] && ruleData[this.alarmSetting.checkbox1.alarmRule][_statusCol] == _enable) {
        // checkbox1啟用時，於畫面初始相關欄位值
        this.advancedCheckList.push(this.alarmSetting.checkbox1.label)
        this.ruleContent.checkbox1PercentInput = this.content.rules[this.alarmSetting.checkbox1.alarmRule].percentage
        this.ruleContent.checkbox1VolumeInput = this.content.rules[this.alarmSetting.checkbox1.alarmRule].volume
      }
      if (ruleData[this.alarmSetting.checkbox2.alarmRule] && ruleData[this.alarmSetting.checkbox2.alarmRule][_statusCol] == _enable) {
        // checkbox2啟用時，於畫面初始相關欄位值
        this.advancedCheckList.push(this.alarmSetting.checkbox2.label)
        this.ruleContent.checkbox2PercentInput = this.content.rules[this.alarmSetting.checkbox2.alarmRule].percentage
        this.ruleContent.checkbox2VolumeInput = this.content.rules[this.alarmSetting.checkbox2.alarmRule].volume
      }
      if (ruleData[this.alarmSetting.checkbox3.alarmRule] && ruleData[this.alarmSetting.checkbox3.alarmRule][_statusCol] == _enable) {
        // checkbox3啟用時，於畫面初始相關欄位值
        this.advancedCheckList.push(this.alarmSetting.checkbox3.label)
        this.ruleContent.checkbox3PercentInput = this.content.rules[this.alarmSetting.checkbox3.alarmRule].percentage
      }
      if (ruleData[this.alarmSetting.checkbox4.alarmRule] && ruleData[this.alarmSetting.checkbox4.alarmRule][_statusCol] == _enable) {
        // checkbox4啟用時，於畫面初始相關欄位值
        this.advancedCheckList.push(this.alarmSetting.checkbox4.label)
        this.ruleContent.checkbox4DaysInput = this.content.rules[this.alarmSetting.checkbox4.alarmRule].days
      }
      if (ruleData[this.alarmSetting.checkbox5.alarmRule] && ruleData[this.alarmSetting.checkbox5.alarmRule][_statusCol] == _enable) {
        // checkbox5啟用時，於畫面初始相關欄位值
        this.advancedCheckList.push(this.alarmSetting.checkbox5.label)
        this.ruleContent.checkbox5DaysInput = this.content.rules[this.alarmSetting.checkbox5.alarmRule].days
      }
      if (ruleData[this.alarmSetting.checkbox6.alarmRule] && ruleData[this.alarmSetting.checkbox6.alarmRule][_statusCol] == _enable) {
        // checkbox6啟用時，於畫面初始相關欄位值
        this.advancedCheckList.push(this.alarmSetting.checkbox6.label)
        this.ruleContent.checkbox6DaysInput = this.content.rules[this.alarmSetting.checkbox6.alarmRule].days
        this.ruleContent.checkbox6HourStartInput = this.content.rules[this.alarmSetting.checkbox6.alarmRule].startHour
        this.ruleContent.checkbox6HourEndInput = this.content.rules[this.alarmSetting.checkbox6.alarmRule].endHour
      }

      if(this.advancedCheckList.length < 1 && !this.alarmRadio) {
        this.alarmRadio = 'radio0'
      }
    },

    // 輸入參數 的輸入限制
    paramInput(e) {
      let key = e.key
      if (key === 'e' || key === '.') {
        e.returnValue = false
        return false
      } else if (key === '' || key === null) {
        e.key = 0
        return true
      } else {
        return true
      }
    },
    // 輸入小數點參數 的輸入限制
    paramInputFloat(e) {
      let key = e.key
      if (key === 'e') {
        e.returnValue = false
        return false
      } else if (key === '' || key === null) {
        e.key = 0
        return true
      } else {
        return true
      }
    },
    // 儲存異常成案規則
    async saveRule() {
      this.saveBtnLoading = true
      // 如果「手機簡訊」&「電子郵件」都沒填
      if ((this.content.notifyPhones.length == 0 || this.checkAryEmpty(this.content.notifyPhones)) && (this.content.notifyMails.length == 0 || this.checkAryEmpty(this.content.notifyMails))) {
        this.$message({
          message: '手機簡訊、電子郵件請擇一填寫',
          type: 'warning'
        })

        this.saveBtnLoading = false
        return
      }
      // console.log('notifyPhones:', this.content.notifyPhones)
      // console.log('notifyMails:', this.content.notifyMails)
      // if (this.content.notifyPhones == '' && )
      // 移除空字串
      this.content.notifyPhones = this.content.notifyPhones.filter(p => p != "")
      this.content.notifyMails = this.content.notifyMails.filter(m => m != "")
      this.setRuleSaveData()

      const ruleFormValid = await this.$refs['ruleForm'].validate().catch((err) => { return err })
      const ruleContentFormValid = await this.$refs['ruleContentForm'].validate().catch((err) => { return err })
      if (!ruleFormValid || !ruleContentFormValid) {
        this.$message({
          message: '未填入必填欄位或欄位有誤',
          type: 'warning'
        })

        this.saveBtnLoading = false
        return
      }

      await this.axios.put('/api/alarm/rule', this.content).then(() => {
        this.$message({
          showClose: true,
          message: '儲存成功',
          type: 'success'
        })

      }).catch(() => {
        this.$message({
          message: '儲存失敗',
          type: 'error'
        })
      }).finally(() => {
        this.saveBtnLoading = false
      })

      this.loading = true
      try{
        // 重新取得頁面規則資料
        await this.getAlarmRules()
      }catch(ex) {
        this.$message({
          message: '發生錯誤',
          type: 'error'
        })
      }finally{
        this.loading = false
      }
    },
    setRuleSaveData() {

      const _statusCol = this.alarmSetting.status.col
      const _enable = this.alarmSetting.status.enable
      const _disable = this.alarmSetting.status.disable

      // Set Radio Data
      if (this.alarmRadio) {
        this.content.rules[this.alarmSetting.radio1.alarmRule][_statusCol] = this.alarmRadio == this.alarmSetting.radio1.label ? _enable : _disable
        this.content.rules[this.alarmSetting.radio2.alarmRule][_statusCol] = this.alarmRadio == this.alarmSetting.radio2.label ? _enable : _disable
        this.content.rules[this.alarmSetting.radio3.alarmRule][_statusCol] = this.alarmRadio == this.alarmSetting.radio3.label ? _enable : _disable
        this.content.rules[this.alarmSetting.radio4.alarmRule][_statusCol] = this.alarmRadio == this.alarmSetting.radio4.label ? _enable : _disable

        switch (this.alarmRadio) {
          case 'radio0':
            break;
          case this.alarmSetting.radio1.label:
            this.content.rules[this.alarmSetting.radio1.alarmRule].percentage = this.ruleContent.radio1PercentInput
            this.content.rules[this.alarmSetting.radio1.alarmRule].volume = this.ruleContent.radio1VolumeInput
            break;
          case this.alarmSetting.radio2.label:
            this.content.rules[this.alarmSetting.radio2.alarmRule].percentage = this.ruleContent.radio2PercentInput
            this.content.rules[this.alarmSetting.radio2.alarmRule].volume = this.ruleContent.radio2VolumeInput
            break;
          case this.alarmSetting.radio3.label:
            this.content.rules[this.alarmSetting.radio3.alarmRule].percentage = this.ruleContent.radio3PercentInput
            this.content.rules[this.alarmSetting.radio3.alarmRule].volume = this.ruleContent.radio3VolumeInput
            break;
          case this.alarmSetting.radio4.label:
            this.content.rules[this.alarmSetting.radio4.alarmRule].percentage = this.ruleContent.radio4PercentInput
            this.content.rules[this.alarmSetting.radio4.alarmRule].volume = this.ruleContent.radio4VolumeInput
            break;
          default:
        }
      } else{
        this.content.rules[this.alarmSetting.radio1.alarmRule][_statusCol] = _disable
        this.content.rules[this.alarmSetting.radio2.alarmRule][_statusCol] = _disable
        this.content.rules[this.alarmSetting.radio3.alarmRule][_statusCol] = _disable
        this.content.rules[this.alarmSetting.radio4.alarmRule][_statusCol] = _disable
      }

      //Set checkbox data
      if (this.advancedCheckList) {
        if (this.advancedCheckList.includes(this.alarmSetting.checkbox1.label)) {
          this.content.rules[this.alarmSetting.checkbox1.alarmRule].percentage = this.ruleContent.checkbox1PercentInput
          this.content.rules[this.alarmSetting.checkbox1.alarmRule].volume = this.ruleContent.checkbox1VolumeInput
          this.content.rules[this.alarmSetting.checkbox1.alarmRule][_statusCol] = _enable
        } else {
          this.content.rules[this.alarmSetting.checkbox1.alarmRule][_statusCol] = _disable
        }

        if (this.advancedCheckList.includes(this.alarmSetting.checkbox2.label)) {
          this.content.rules[this.alarmSetting.checkbox2.alarmRule].percentage = this.ruleContent.checkbox2PercentInput
          this.content.rules[this.alarmSetting.checkbox2.alarmRule].volume = this.ruleContent.checkbox2VolumeInput
          this.content.rules[this.alarmSetting.checkbox2.alarmRule][_statusCol] = _enable
        } else {
          this.content.rules[this.alarmSetting.checkbox2.alarmRule][_statusCol] = _disable
        }

        if (this.advancedCheckList.includes(this.alarmSetting.checkbox3.label)) {
          this.content.rules[this.alarmSetting.checkbox3.alarmRule].percentage = this.ruleContent.checkbox3PercentInput
          this.content.rules[this.alarmSetting.checkbox3.alarmRule][_statusCol] = _enable
        } else {
          this.content.rules[this.alarmSetting.checkbox3.alarmRule][_statusCol] = _disable
        }

        if (this.advancedCheckList.includes(this.alarmSetting.checkbox4.label)) {
          this.content.rules[this.alarmSetting.checkbox4.alarmRule].days = this.ruleContent.checkbox4DaysInput
          this.content.rules[this.alarmSetting.checkbox4.alarmRule][_statusCol] = _enable
        } else {
          this.content.rules[this.alarmSetting.checkbox4.alarmRule][_statusCol] = _disable
        }

        if (this.advancedCheckList.includes(this.alarmSetting.checkbox5.label)) {
          this.content.rules[this.alarmSetting.checkbox5.alarmRule].days = this.ruleContent.checkbox5DaysInput
          this.content.rules[this.alarmSetting.checkbox5.alarmRule][_statusCol] = _enable
        } else {
          this.content.rules[this.alarmSetting.checkbox5.alarmRule][_statusCol] = _disable
        }

        if (this.advancedCheckList.includes(this.alarmSetting.checkbox6.label)) {
          this.content.rules[this.alarmSetting.checkbox6.alarmRule].days = this.ruleContent.checkbox6DaysInput
          this.content.rules[this.alarmSetting.checkbox6.alarmRule].startHour = this.ruleContent.checkbox6HourStartInput
          this.content.rules[this.alarmSetting.checkbox6.alarmRule].endHour = this.ruleContent.checkbox6HourEndInput
          this.content.rules[this.alarmSetting.checkbox6.alarmRule][_statusCol] = _enable
        } else {
          this.content.rules[this.alarmSetting.checkbox6.alarmRule][_statusCol] = _disable
        }
      }
    },
    // 確認是否 全為 空字串
    checkAryEmpty(arr) {
      let empty = 1
      arr.forEach(element => {
        if (element == '') {
          empty = empty && 1
        } else {
          empty = empty && 0
        }
      });
      return empty
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table,
.el-table__expanded-cell {
  background-color: transparent;

  th,
  td {
    background-color: transparent;
  }

  .el-table__expanded-cell {
    background-color: transparent !important;
  }

  th.el-table__cell {
    background-color: #3478BC;
    color: #FFF
  }

  tr>td {
    background-color: #F5FBFE
  }

  // hover 效果
  tr:hover>td {
    background-color: #D9ECF7 !important;
  }

  tbody tr:hover>td {
    background-color: #D9ECF7 !important;
  }
}

::v-deep .el-input__inner {
  padding: 5 10px;
}

::v-deep .param-valid-form .el-form-item__content {
  margin-left: 0px !important;
}


</style>